// extracted by mini-css-extract-plugin
export default {"main":"index_main__3sM0q","mainArea":"index_mainArea__nottD","fullWidth":"index_fullWidth__ns2wL","isMobile":"index_isMobile__JeFCH","operationArea":"index_operationArea__aPkma"};